import React, { FC, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'antd';
import { IBet, IMatch } from '../types';
import { useStore } from '@/app/providers/StoreProvider';

interface PropsTicketMatch {
  match: IMatch
  isActual:boolean
  isAcceptingBets:boolean
  isBet:IBet | undefined
}



export const TicketMatch:FC<PropsTicketMatch> = observer(({match, isActual, isAcceptingBets, isBet}) => {

  const { forecastStore } = useStore();

  const isFilled = forecastStore.isBetFilled();

  if(!isActual) return null;

  return (
    <div className='forecast-menu '>

      <div className={`forecast-menu_img ${isBet?'forecast-menu_img__gray':isFilled?'forecast-menu_img__blue':'forecast-menu_img__white'}`}></div>
      {!isBet?isFilled
      ?<h2 className='forecast-menu_title'>Ваш прогноз: {forecastStore.bet.homeScore}:{forecastStore.bet.awayScore}, {forecastStore.bet.oviGoals}+{forecastStore.bet.oviHelps}</h2>
      :<h2 className='forecast-menu_title'>Сделайте свой прогноз!</h2>
      :null
      }
      <button
        type='button'
        className='forecast-menu_button'
        onClick={()=>{forecastStore.setBet(match.id)}}
        disabled={!isFilled || !!isBet || !isAcceptingBets }
      >
        {isBet?`Ваш прогноз: ${isBet.homeScore}:${isBet.awayScore}, ${isBet.oviGoals}+${isBet.oviHelps}`:'Сохранить прогноз'}
      </button>
      {
        isBet
        ?<p className={`forecast-menu_text white`}>Внимание: вы уже сделали прогноз на этот матч</p>
        : <p className={`forecast-menu_text`}>Внимание: cделать прогноз можно только один раз!</p>
      }

      <div className='forecast-menu_shadow'></div>
    </div>
  );


});
